import type { Router } from 'vue-router'

type BroadcastMessage = { type: 'ping' | 'pong' }

let initialized = false

/**
 * Initialize the multi-instance warning system that warns the user
 * when they have the same configurator opened in multiple tabs
 */
export function initMultiInstanceWarning(router: Router) {
  if (initialized) return
  initialized = true

  const requestMetaStore = useRequestMetaStore()

  // Communicate warnings to the user
  watch(
    () => requestMetaStore.uuid,
    uuid => {
      if (!uuid) return

      const { post, data } = useBroadcastChannel<BroadcastMessage, BroadcastMessage>({ name: uuid })

      watch(data, value => {
        switch (value?.type) {
          case 'ping':
            post({ type: 'pong' })
            break

          case 'pong':
            const route = useStepsStore().getChildPath('warnung-mehrere')
            if (!route) break
            router.push(route)
            break
        }
      })

      post({ type: 'ping' })
    },
    { immediate: true },
  )
}
